<template>
    <div class="content">
        <div class="container doc-container">
          <h3>{{$t('docking.docSdkWord')}}</h3>
          <div class="doc-info">
            {{$t('docking.tipOne')}}【{{$t('docking.tipThree')}}】{{$t('docking.tipTwo')}}
          </div>
          <el-table :data="tableData" class="table">
            <el-table-column prop="name" :label="$t('docking.document')" align="left">
              <template slot-scope="scope">
                <!-- <a :href="scope.row.url" type="primary" :underline="false" target="_blank">{{scope.row.name}}</a> -->
                <span class="file" @click="fileDown(scope.row.url)">{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updateDate" :label="$t('docking.updateDate')" align="left"></el-table-column>
            <el-table-column prop="version" :label="$t('docking.version')" align="left"></el-table-column>
          </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogFormVisible: false,
        }
    },
    computed:{
      tableData(){
        return [
          {
            name: this.$t('docking.AndroidWord'), //多盟SDK对接文档
            updateDate: "2025-8-14",
            version: "2.2.1",
            url: "https://bluefocus.feishu.cn/wiki/Ds6dwulrHist2HkCbbQcYwXln9g",
          },
          {
            name: this.$t('docking.IOSWord'), //多盟SDK对接文档
            updateDate: "2025-9-22",
            version: "2.3.4",
            url: "https://bluefocus.feishu.cn/wiki/LxarwTq8hitXOakkJWYc0Zx6n5e",
          },
          // {
          //   name: this.$t('docking.templateFile'), //模板文件
          //   updateDate: "2023-12-08",
          //   version: "V1.0",
          //   // url: "https://dm-langding-qiniu.domob.cn/2022/adxFile/%E5%B9%BF%E5%91%8A%E6%A8%A1%E6%9D%BF%E6%A0%B7%E5%BC%8F%E8%A1%A8V2.12.xlsx",
          // },
          // {
          //   name: this.$t('docking.domobSdk'), //多盟sdk
          //   updateDate: "2023-12-08",
          //   version: "V1.0",
          //   // url: "https://dm-langding-qiniu.domob.cn/2022/adxFile/domob-ssp2.15.rtf.zip",
          // },
          // {
          //   name: this.$t('docking.updateLog'), //更新日志
          //   updateDate: "2023-12-08",
          //   version: "V1.0",
          //   // url: "https://dm-langding-qiniu.domob.cn/2022/adxFile/domob-ssp2.15.rtf.zip",
          // },
        ]
      }
    },
    created() {
    },
    methods: {
      fileDown(url) {
        window.open(url)
      }
    }
}
</script>
<style>
.doc-title{
    padding-bottom: 20px;
    font-size: 28px;
    color: #2c3e50;
}
.dl-title{
  font-size:16px;
  line-height: 40px;
}
.dl-desc {
  line-height: 40px;
}
.table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.doc-info {
  margin-bottom: 34px;
  margin-top: 14px;
  font-size: 14px;
}
.file {
  cursor: pointer;
  color: #3361ff;
}
</style>
